// utils/modules/numbers — Persian/Arabic digit conversion helpers.
import { removeSpaces } from "../spaces";
import numbersMapping from "../utf8-codes/numberMapping";

/**
 * تبدیل اعداد فارسی و عربی به اعداد انگلیسی
 * کاراکترهای غیرعددی دست‌نخورده می‌مانند.
 *
 * مثال: "۱۴۰۳-۱۱-۱۵" → "1403-11-15"
 */
const persianToEnglishNumber = (text: string): string => {
  if (!text || text === "") return "";

  return text
    .split("")
    .map((c) => {
      const mapped = numbersMapping[c.charCodeAt(0)];
      return mapped || c;
    })
    .join("");
};

/**
 * استخراج فقط اعداد از یک رشته و حذف بقیه کاراکترها
 * ابتدا اعداد فارسی/عربی به انگلیسی تبدیل و سپس بقیه حذف می‌شوند.
 *
 * مثال: "قیمت: ۱۲۳,۴۵۶ تومان" → "123456"
 */
const extractNumbers = (text: string): string | undefined => {
  if (!text || text === "") return;

  const normalized = persianToEnglishNumber(text).replace(/[^0-9]/g, "");

  return removeSpaces(normalized);
};

export { persianToEnglishNumber, extractNumbers };
